import { sortBy } from 'lodash';

const profileManagers = (mg) => {
  return sortBy(
    mg.map((m) => {
      const mgOption = {
        ...m,
        ...{
          label: m.displayName.split(' ').slice(0, -1).join(' '),
          value: m.userUuid,
        },
      };

      return mgOption;
    }),
    'label',
  );
};

export default profileManagers;
